import { render, staticRenderFns } from "./AppAiIcon.vue?vue&type=template&id=57ccf51e"
import script from "./AppAiIcon.vue?vue&type=script&lang=js"
export * from "./AppAiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports